<template>
  <iframe
    :src="`${pdfUrl}#toolbar=${props.hideToolbar ? 0 : 1}`"
    class="block w-full object-contain"
    :type="MimeTypes.PDF"
    :class="{ 'min-h-[40rem]': props.isExpanded, 'max-h-[40rem]': !props.isExpanded }"
    width="100%"
    height="100%"
  />
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';

import { MimeTypes } from '@/types/general';

const props = defineProps<{
  base64Data?: string;
  binaryData?: ArrayBuffer;
  isExpanded: boolean;
  hideToolbar?: boolean; // hiding toolbar is currently only supported in chrome
}>();

const pdfUrl = ref('');

onMounted(() => {
  renderPdf();
});

function decodeUTF8(b64: string): Uint8Array {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
}

function renderPdf() {
  let data: Uint8Array | undefined = undefined;
  if (!!props.base64Data) {
    data = decodeUTF8(props.base64Data);
  } else if (!!props.binaryData) {
    data = new Uint8Array(props.binaryData);
  }
  if (!!data) {
    const blob = new Blob([data], { type: MimeTypes.PDF });
    pdfUrl.value = URL.createObjectURL(blob);
  }
}
</script>
